import { Dispatch, SetStateAction } from 'react';
import { IAsyncType, useAsync } from '.';

import { ItemCategoryResponse } from '../../services/api';
import { amsLegacyService } from '../../services';

export interface ICategories<T> extends IAsyncType<T> {
  categories: T;
  setCategories: Dispatch<SetStateAction<T>>;
}

/**
 *
 * @deprecated
 */
const useItemCategories = (leafOnly: boolean = false): ICategories<ItemCategoryResponse[]> => {
  const { data, setData, loading, setLoading, parameters, setParameters } = useAsync<
    ItemCategoryResponse[]
  >(amsLegacyService.getCategoriesFlat, [], [leafOnly]);
  return {
    categories: data,
    setCategories: setData,
    loading,
    setLoading,
    parameters,
    setParameters
  };
};

export default useItemCategories;
